function enhanceSccFaqPage() {
  const root = document.querySelector('#MainContent[data-scc-page-handle="faq"]');
  const formatter = root?.querySelector('.page-content rte-formatter');

  if (!formatter || formatter.dataset.sccFaqEnhanced === 'true') return;

  const nodes = Array.from(formatter.children);
  const list = document.createElement('div');
  const leadingNodes = [];
  let activeAnswer = null;
  let itemIndex = 0;

  formatter.dataset.sccFaqEnhanced = 'true';
  list.className = 'scc-faq-list';

  nodes.forEach((node) => {
    if (node.matches('h2')) {
      itemIndex += 1;

      const item = document.createElement('details');
      const summary = document.createElement('summary');
      const number = document.createElement('span');
      const answer = document.createElement('div');
      const answerInner = document.createElement('div');
      const icon = document.createElement('span');
      const headingId = node.id || `scc-faq-question-${itemIndex}`;

      node.id = headingId;
      item.className = 'scc-faq-item';
      item.setAttribute('name', 'scc-faq');
      item.open = itemIndex === 1;
      summary.className = 'scc-faq-item__summary';
      number.className = 'scc-faq-item__number';
      number.setAttribute('aria-hidden', 'true');
      number.textContent = String(itemIndex).padStart(2, '0');
      answer.className = 'scc-faq-item__answer';
      answer.setAttribute('role', 'region');
      answer.setAttribute('aria-labelledby', headingId);
      icon.className = 'scc-faq-item__icon';
      icon.setAttribute('aria-hidden', 'true');

      summary.append(number, node, icon);
      answer.append(answerInner);
      item.append(summary, answer);
      list.append(item);
      activeAnswer = answerInner;
      return;
    }

    if (activeAnswer) {
      activeAnswer.append(node);
    } else {
      leadingNodes.push(node);
    }
  });

  formatter.replaceChildren(...leadingNodes, list);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', enhanceSccFaqPage, { once: true });
} else {
  enhanceSccFaqPage();
}

document.addEventListener('shopify:section:load', enhanceSccFaqPage);
